import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TfUserDataService } from './services/tf-user-data.service';
import { TfWindowRefService } from '../tf-window-ref';

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [
        TfUserDataService,
        TfWindowRefService
    ]
})
export class TfUserDataModule {
}
